// scripts/shopify/theme/preorder.js
// Pre-order PDP + cart enhancements.
//
// Reads window.PREORDER_PRODUCT (set by preorder-badge.liquid on the PDP)
// and, if set, swaps the ATC button text + injects line-item properties
// on add-to-cart so the ETA propagates to cart, checkout, confirmation,
// and packing slip.
(function () {
  "use strict";

  function formatDate(isoDate) {
    if (!isoDate) return "";
    var d = new Date(isoDate + "T12:00:00Z");
    return d.toLocaleDateString("en-US", {
      month: "long", day: "numeric", year: "numeric"
    });
  }

  function applyPdp() {
    var cfg = window.PREORDER_PRODUCT;
    if (!cfg || !cfg.ship_date) return;

    var pretty = formatDate(cfg.ship_date);
    var btn = document.querySelector("form[action*='/cart/add'] button[type='submit']");
    if (btn) {
      var span = btn.querySelector("span") || btn;
      span.textContent = "Pre-order: Ships " + pretty;
    }
  }

  function attachCartAddFields() {
    var cfg = window.PREORDER_PRODUCT;
    if (!cfg || !cfg.selling_plan_id) return;
    // selling_plan — binds the line item to the Selling Plan so Shopify
    // creates a SCHEDULED fulfillment order. The selling plan's NAME carries
    // the ship date in the cart, so we don't add line-item properties.
    document.querySelectorAll("form[action*='/cart/add']").forEach(function (form) {
      if (!form.querySelector('input[name="selling_plan"]')) {
        var sp = document.createElement("input");
        sp.type = "hidden";
        sp.name = "selling_plan";
        sp.value = cfg.selling_plan_id;
        form.appendChild(sp);
      }
    });
  }

  // Intercept programmatic /cart/add.js / /cart/add fetches so the
  // Selling Plan binding works even when the storefront uses AJAX.
  function patchFetch() {
    var cfg = window.PREORDER_PRODUCT;
    if (!cfg || !cfg.selling_plan_id) return;
    var origFetch = window.fetch;
    if (!origFetch || origFetch._preorderPatched) return;
    var patched = function (input, init) {
      try {
        var url = typeof input === "string" ? input : (input && input.url) || "";
        if (init && init.body && /\/cart\/add(\.js)?($|\?)/.test(url)) {
          var ct = (init.headers && (init.headers["Content-Type"] || init.headers["content-type"])) || "";
          if (init.body && typeof init.body === "string" && ct.indexOf("application/json") !== -1) {
            try {
              var body = JSON.parse(init.body);
              if (body && body.items && body.items.length) {
                body.items.forEach(function (it) {
                  if (!it.selling_plan) it.selling_plan = cfg.selling_plan_id;
                });
                init.body = JSON.stringify(body);
              } else if (body && body.id && !body.selling_plan) {
                body.selling_plan = cfg.selling_plan_id;
                init.body = JSON.stringify(body);
              }
            } catch (e) { /* not JSON or unparseable — skip */ }
          }
        }
      } catch (e) { /* never throw from a fetch interceptor */ }
      return origFetch.apply(this, arguments);
    };
    patched._preorderPatched = true;
    window.fetch = patched;
  }

  function init() {
    applyPdp();
    attachCartAddFields();
    patchFetch();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
